import type { Strings } from "./strings.en";

export const te: Partial<Strings> = {
  nav_home: "హోమ్",
  nav_drill: "డ్రిల్ ప్రయత్నించండి",
  nav_new: "వాల్ట్ సీల్ చేయండి",
  nav_checkin: "చెక్-ఇన్",
  nav_custodian: "సంరక్షకులు",
  nav_vaults: "అన్ని వాల్ట్‌లు",
  nav_verify: "మా అవసరం లేకుండా ధృవీకరించండి",

  hero_kicker: "RTI కార్యకర్తలు, విజిల్‌బ్లోయర్లు, వారికి అండగా నిలిచేవారి కోసం",
  hero_title: "నా గుండె ఆగితే, నిజం బయటకు వస్తుంది.",
  hero_body: "భారతదేశ RTI దరఖాస్తుదారుల కోసం: మీ జవాబు గడువు, అప్పీల్ తేదీలు ఈరోజే తెలుసుకోండి. పని ప్రమాదకరంగా మారితే, మీ సాక్ష్యాన్ని సీల్ చేయండి, మిమ్మల్ని నోరు మూయిస్తే అది బయటకు వస్తుంది.",
  hero_cta_drill: "5 నిమిషాల్లో జరగడం చూడండి",
  hero_cta_new: "నిజమైన వాల్ట్ సీల్ చేయండి",
  hero_note: "Arkiv యొక్క Tiramisu టెస్ట్‌నెట్‌పై నడుస్తుంది. టెస్ట్ పత్రాలను మాత్రమే వాడండి.",

  why_title: "ఇది ఎందుకు అవసరం",
  why_1: "మంది 2005 నుండి RTI చట్టం కింద సమాచారం అడిగినందుకు హత్యకు గురయ్యారు (CHRI ట్రాకర్).",
  why_2_n: "12 ఏళ్లు",
  why_2: "గా విజిల్ బ్లోయర్స్ రక్షణ చట్టం, 2014 అమలులోకి రావడానికి ఎదురుచూస్తోంది.",
  why_3: "కార్యకర్తను నోరు మూయిస్తే వారి ఆధారాలను ఆటోమేటిక్‌గా విడుదల చేసే సాధనాలు.",
  why_story: "మహారాష్ట్రలో RTI కార్యకర్తల హత్యల తర్వాత, కొన్ని కుటుంబాలు భయంతో పత్రాలను కాల్చేశాయని పరిశోధకులు గుర్తించారు. హత్యకు గురైన కార్యకర్త అడిగిన సమాచారాన్ని వెంటనే బహిరంగపరచాలని సమాచార కమిషన్ ఒకసారి ఆదేశించింది. Proof of Life ఆ ఆదేశాన్ని ఆటోమేటిక్‌గా అమలు చేస్తుంది, హత్యకు కారణాన్నే తీసేస్తుంది.",

  how_title: "ఇది ఎలా పనిచేస్తుంది",
  how_1_t: "సీల్",
  how_1: "మీ ఫైళ్లు ఈ బ్రౌజర్‌లోనే ఎన్‌క్రిప్ట్ అవుతాయి. Arkiv కి ఎన్‌క్రిప్ట్ చేసిన డేటా మాత్రమే వెళ్తుంది, అది ఎవరి నియంత్రణలోనూ లేని చిరునామాకు అప్పగించబడుతుంది. కాబట్టి దాన్ని ఎవరూ తొలగించలేరు, మీరు కూడా.",
  how_2_t: "సంరక్షకులను ఎంచుకోండి",
  how_2: "ఒక జర్నలిస్ట్, ఒక లాయర్, ఒక స్నేహితుడు. ప్రతి ఒక్కరి దగ్గర తాళంచెవిలో ఒక ముక్క ఉంటుంది. వారిలో ఏ {k} మంది కలిసినా వాల్ట్ తెరవగలరు; అంతకంటే తక్కువ మందికి ఏమీ తెలియదు.",
  how_3_t: "చెక్-ఇన్",
  how_3: "మీ గుండె చప్పుడు Arkiv లో ఒక ఎంటిటీ, దాన్ని మీ తాళంచెవి మాత్రమే బతికించగలదు. ఒక్క ట్యాప్ దాన్ని ముందుకు నెడుతుంది. గడువు, గ్రేస్ సమయం దాటితే, అది ఉనికిలో లేకుండా పోతుంది.",
  how_4_t: "విడుదల",
  how_4: "గుండె చప్పుడు ఆగిందని సంరక్షకులు చూసి తమ ముక్కలను ప్రచురిస్తారు. సరిపడా ముక్కలు బహిరంగమైన వెంటనే, ఎవరి బ్రౌజర్ అయినా పత్రాలను తెరవగలదు. ఏ సర్వర్ నిర్ణయించదు.",

  phase_alive: "సజీవం",
  phase_overdue: "ఆలస్యం",
  phase_lapsed: "గుండె ఆగింది",
  phase_releasing: "విడుదల అవుతోంది",
  phase_released: "విడుదలైంది",
  phase_alive_d: "చెక్-ఇన్ అయింది. పత్రాలు సీల్‌లోనే ఉంటాయి.",
  phase_overdue_d: "చెక్-ఇన్ సమయం దాటింది. సంరక్షకులు ఇప్పుడే కార్యకర్తను సంప్రదించడానికి ప్రయత్నించాలి.",
  phase_lapsed_d: "గడువులోపు చెక్-ఇన్ జరగలేదు. సంరక్షకులు ఇప్పుడు తమ ముక్కలను ప్రచురించవచ్చు.",
  phase_releasing_d: "{k} లో {have} ముక్కలు బహిరంగమయ్యాయి. ఇంకా {need} వస్తే వాల్ట్ తెరుచుకుంటుంది.",
  phase_released_d: "సరిపడా ముక్కలు బహిరంగమయ్యాయి. ఈ పత్రాలను ఎవరైనా తెరవవచ్చు.",

  t_due_in: "చెక్-ఇన్ గడువు",
  t_lapses_in: "గుండె ఆగే సమయం",
  early_release: "హెచ్చరిక: గుండె చప్పుడు ఉండగానే ఒక సంరక్షకుడు తన ముక్కను ప్రచురించారు. ఇది నియమాల ఉల్లంఘన. ఈ వాల్ట్‌ను రాజీపడినదిగా పరిగణించండి.",

  v_custodians: "సంరక్షకులు",
  v_custodian_slot: "స్లాట్ {slot}",
  v_ack_live: "తాళంచెవి దగ్గర ఉంది · {time} లో పునరుద్ధరణ",
  v_ack_missing: "ఇంకా నిర్ధారించలేదు",
  v_released_piece: "ముక్క ప్రచురించబడింది",
  v_open: "పత్రాలను తెరవండి",
  v_opening: "తాళంచెవిని తిరిగి కూర్చి డీక్రిప్ట్ చేస్తోంది…",
  v_files: "పత్రాలు",
  v_verified: "ప్రతి ఫైల్ బ్లాక్ {block} వద్ద సీల్ చేసిన హ్యాష్‌తో సరిపోలుతోంది. ఇవి {date} నాటి పత్రాలే.",
  v_sealed_yes: "సీల్ అయింది: చదవడానికి మాత్రమే, ఎవరి దగ్గరా తాళంచెవి లేని చిరునామా స్వంతం",
  v_sealed_no: "సీల్ కాలేదు: సృష్టించినవారు ఇంకా దీన్ని తొలగించగలరు",
  v_rejected: "పట్టించుకోని ఎంటిటీలు",
  v_rejected_d: "ఇవి ఈ వాల్ట్‌కు చెందినవని చెప్పుకుంటాయి, కానీ నమ్మక పరీక్షలో విఫలమయ్యాయి. వీటిని ఎవరైనా రాయవచ్చు; లెక్కలోకి మాత్రం ఎవరూ తేలేరు.",
  v_keepalive: "ఈ వాల్ట్‌ను ఈ రోజు నుంచి కనీసం ఏడాది బతికించండి",
  v_keepalive_d: "సీల్ చేసిన డేటా జీవితకాలాన్ని ఎవరైనా పొడిగించవచ్చు. మీరు కొంచెం టెస్ట్ గ్యాస్ చెల్లిస్తారు; దేన్నీ మార్చలేరు, తొలగించలేరు.",
  v_newsroom: "ఈ ముక్కలు న్యూస్‌రూమ్ తాళంచెవితో సీల్ అయ్యాయి. ఆ న్యూస్‌రూమ్ మాత్రమే పత్రాలను తెరిచి ఏమి ప్రచురించాలో నిర్ణయించగలదు.",
  v_live: "లైవ్",
  v_events: "లైవ్ కార్యకలాపం",

  use_title: "ఇది దేని కోసం, దేని కోసం కాదు",
  use_body: "Proof of Life తమ చట్టపరమైన హక్కులను వినియోగించే వారికి, అంటే RTI దరఖాస్తుదారులు, జర్నలిస్టులు, లాయర్లకు, చట్టబద్ధంగా పొందిన రికార్డులు వారి తర్వాత కూడా నిలిచేలా సహాయపడుతుంది. RTI సమాధానాలు, పబ్లిక్ రికార్డులు, మీ సొంత ఆధారాలను సీల్ చేయండి. రహస్య ప్రభుత్వ సమాచారం, ఇతరుల వ్యక్తిగత సమాచారం, చట్టబద్ధంగా ఉంచుకోలేని దేన్నీ సీల్ చేయకండి. నిజమైన వినియోగంలో న్యూస్‌రూమ్‌కు విడుదల చేయండి, ప్రచురణకు ముందు సంపాదకులు పత్రాలను తనిఖీ చేస్తారు. ఈ వెర్షన్ టెస్ట్ నెట్‌వర్క్‌పై కల్పిత పత్రాలతో మాత్రమే నడుస్తుంది.",
  hero_title_a: "నా గుండె ఆగితే,",
  hero_title_b: "నిజం బయటకు వస్తుంది.",
  trust_1: "ఉచితం, ఓపెన్ సోర్స్",
  trust_2: "వాలెట్ లేదా యాప్ ఇన్‌స్టాల్ అవసరం లేదు",
  why_h2_a: "ఆధారాలు కనుగొన్నవారితో పాటే",
  why_h2_b: "అవీ చనిపోతాయి.",
  old_eyebrow: "ఈ రోజు",
  old_title: "ల్యాప్‌టాప్‌లో ఒక ఫోల్డర్, స్నేహితుడి దగ్గర ఒక కాపీ",
  old_1: "ల్యాప్‌టాప్‌ను స్వాధీనం చేసుకోవచ్చు, డ్రైవ్‌ను తుడిచేయవచ్చు.",
  old_2: "ఒకే కాపీ ఉన్న స్నేహితుడిని బెదిరించి నోరు మూయించవచ్చు.",
  old_3: "చాలా ఆలస్యమయ్యే వరకు ఆ కాగితాలు ఉన్నాయని ఇంకెవరికీ తెలియదు.",
  new_eyebrow: "Proof of Life తో",
  new_title: "తన సమయానికే తెరుచుకునే సీల్ చేసిన రికార్డు",
  new_1: "ఎన్‌క్రిప్ట్ చేసిన రికార్డు Arkiv లో ఉంటుంది, దాన్ని ఎవరూ తొలగించలేరు.",
  new_2: "విడుదల ఏ ఒక్క వ్యక్తి, సర్వర్ లేదా కంపెనీపై ఆధారపడదు.",
  new_3: "కార్యకర్తను చంపితే ఆధారాలు దాగవు, బయటకు వస్తాయి.",
  f1_title: "మీ ఫోన్‌లో ఎన్‌క్రిప్ట్, Arkiv లో చెరగనిది.",
  f2_title: "మీరు ఎంచుకున్నవారి మధ్య నమ్మకం పంచబడుతుంది.",
  f3_title: "వారానికి ఒక్క ట్యాప్, అంతా సీల్‌లోనే.",
  f4_title: "గుండె ఆగగానే, ఎవరైనా చదవగలరు.",
  try_eyebrow: "ఈ పేజీలోనే ప్రయత్నించండి",
  try_h2: "ఒక ఏడాది చెక్-ఇన్‌లు, ఒక్క నిమిషంలో.",
  try_lead: "ఒక రిథమ్ ఎంచుకుని, ఎంతమంది సంరక్షకులు అంగీకరించాలో నిర్ణయించండి. తర్వాత చెక్-ఇన్ ఆపేసి ఏమి జరుగుతుందో చూడండి. ప్రతి సెకనుకు ఒక రోజు గడుస్తుంది.",
  sim_rhythm: "చెక్-ఇన్ రిథమ్",
  sim_k: "విడుదలకు కావాల్సిన సంరక్షకులు: {k}",
  sim_auto: "నేను చెక్-ఇన్ చేస్తూనే ఉంటాను",
  sim_auto_d: "మౌనంగా ఉండాలంటే దీన్ని ఆపండి.",
  sim_checkin: "ఇప్పుడే చెక్-ఇన్",
  sim_reset: "మళ్లీ మొదలుపెట్టండి",
  sim_note: "ఈ బాక్స్ ఈ పేజీలోనే జరిగే సిమ్యులేషన్. డ్రిల్ ఇదే పనిని నిజమైన Arkiv టెస్ట్‌నెట్‌పై చేస్తుంది.",
  sim_due: "తదుపరి చెక్-ఇన్ {d} రోజుల్లో",
  arkiv_eyebrow: "ఇది Arkiv పై ఎందుకు నడుస్తుంది",
  arkiv_h2_a: "గడువును డేటాబేస్ కాపాడుతుంది.",
  arkiv_h2_b: "ఎవరూ సర్వర్ నడుపుతూ ఉండాల్సిన అవసరం లేదు.",
  faq_eyebrow: "ప్రశ్నలు",
  faq_h2: "ప్రజలు ముందుగా అడిగేవి.",
  faq_1_q: "విడుదలను ఎవరైనా ఆపగలరా?",
  faq_1_a: "Arkiv గడువును అమలు చేస్తుంది, ఎన్‌క్రిప్ట్ చేసిన రికార్డును ఉంచుతుంది. విడుదలకు మీ సంరక్షకుల్లో k మంది తమ ముక్కలను ప్రచురించాలి. వారిలో సరిపడా మందిని నోరు మూయిస్తే లేదా వారు నిరాకరిస్తే, వాల్ట్ సీల్‌లోనే ఉంటుంది. అందుకే వేర్వేరు చోట్ల ఉన్నవారిని ఎంచుకుని, k ను మొత్తం కంటే తక్కువగా ఉంచండి.",
  faq_2_q: "నా ఫోన్ పోతే?",
  faq_2_a: "కొత్త ఫోన్‌లో మీ బ్యాకప్ ఫైల్‌ను పునరుద్ధరించి పాస్‌ఫ్రేజ్ నమోదు చేయండి. బ్యాకప్‌ను ఫోన్‌కు దూరంగా, ఉదాహరణకు నమ్మకమైన వ్యక్తి దగ్గర ఉంచండి. పాస్‌ఫ్రేజ్ లేకుండా అది అర్థం లేని టెక్స్ట్.",
  faq_3_q: "ఎవరైనా బలవంతంగా చెక్-ఇన్ చేయిస్తే?",
  faq_3_a: "వాల్ట్ సృష్టించేటప్పుడు ఒక ఒత్తిడి పాస్‌ఫ్రేజ్ (duress) పెట్టండి. దానితో చేసిన చెక్-ఇన్ మీ స్క్రీన్‌పైనా, పబ్లిక్ పేజీలోనూ సాధారణంగానే కనిపిస్తుంది. ప్రతి చెక్-ఇన్‌తో సంరక్షకులకు ఎన్‌క్రిప్ట్ చేసిన ఒక నోట్ వెళ్తుంది, ఇది వారిని వెంటనే విడుదల చేయమని చెబుతుంది.",
  final_a: "మీ ఆధారాలను ఒంటరిగా ఉంచుకోకండి.",
  final_b: "వాటిని సీల్ చేసి, చెక్-ఇన్ చేస్తూ ఉండండి.",
  final_cta_2: "విడుదలైన వాల్ట్ చూడండి",
  common_loading: "Arkiv నుండి చదువుతోంది…",
  common_error: "Arkiv నుండి చదవలేకపోయాం",
  common_retry: "మళ్లీ ప్రయత్నించండి",
  common_copy: "కాపీ",
  common_copied: "కాపీ అయింది",
  common_testnet: "టెస్ట్‌నెట్ మాత్రమే. ఇక్కడ ఎప్పుడూ నిజమైన వ్యక్తిగత సమాచారాన్ని సీల్ చేయకండి.",
  read_direct: "నేరుగా Arkiv నుండి చదువుతోంది",
  read_relay: "మా రిలే ద్వారా చదువుతోంది (Arkiv ఉచిత పరిమితి ముగిసింది)",
  vl_all: "అన్నీ",
  vl_soon: "3 రోజుల్లో ఆగేవి",
  vl_slow: "వారానికోసారి లేదా తక్కువ చెక్-ఇన్",
  vl_filter_note: "ఈ ఫిల్టర్లు Arkiv నోడ్‌పై ప్రతి హార్ట్‌బీట్ గడువు, ప్రతి వాల్ట్ చెక్-ఇన్ విరామంపై రేంజ్ క్వెరీలుగా నడుస్తాయి.",
  vl_rel_t: "విడుదలైన సాక్ష్యం",
  vl_rel_b: "ముక్కలు పబ్లిక్ అయిన వాల్ట్‌లు. హార్ట్‌బీట్ కొనసాగుతున్నప్పుడు వాల్ట్ జాబితాలో లేకుండా ఉండవచ్చు; విడుదలైన ప్రతి ముక్కపై ప్రాజెక్ట్ ట్యాగ్, వాల్ట్ సృష్టికర్త ఉంటాయి, కాబట్టి విడుదలైన సాక్ష్యాన్ని చెయిన్ నుంచే కనుగొనవచ్చు.",
  vl_pieces: "{n} ముక్క(లు) · బ్లాక్ {b} నుంచి",
  vl_intro: "Arkiv‌లో జాబితాలో ఉన్న ప్రతి వాల్ట్, నేరుగా చదివినది. వాల్ట్ ఒక యాదృచ్ఛిక id, సంరక్షకుల సంఖ్య, దాని హార్ట్‌బీట్ మాత్రమే చూపిస్తుంది. దాన్ని ఎవరు చేశారో, లోపల ఏముందో ఇక్కడ ఏదీ చెప్పదు. విడుదలల లెక్కలో వాల్ట్ తనిఖీలో నెగ్గిన ముక్కలే ఉంటాయి; నకిలీ ముక్కలు విడిగా చూపబడతాయి.",
  vl_row: "{n}లో {k} సంరక్షకులు · {mode} విడుదల · {by} ద్వారా",
  rti_bk_t: "రెండో అప్పీల్ వరకు వెళ్లాల్సి వస్తే",
  rti_bk_lead: "రెండో అప్పీల్ మీ రాష్ట్ర సమాచార కమిషన్‌కు, కేంద్ర ప్రభుత్వ కార్యాలయమైతే కేంద్ర సమాచార కమిషన్‌కు వెళ్తుంది. మీ కమిషన్‌ను ఎంచుకుని అక్కడ ఎన్ని కేసులు పెండింగ్‌లో ఉన్నాయో చూడండి.",
  rti_bk_pick: "సమాచార కమిషన్",
  rti_bk_choose: "కమిషన్‌ను ఎంచుకోండి",
  rti_bk_wait: "1 జూలై 2025న దాఖలైన కేసు పరిష్కారానికి అంచనా నిరీక్షణ: {wait}.",
  rti_bk_years: "{y} సంవత్సరాలు",
  rti_bk_years_months: "{y} సంవత్సరాల {m} నెలలు",
  rti_bk_defunct: "7 అక్టోబర్ 2025 నాటికి ఈ కమిషన్‌లో ఒక్క కమిషనర్ కూడా లేరు, కాబట్టి అప్పీళ్లు వినేవారు లేరు.",
  rti_bk_nochief: "అక్టోబర్ 2025లో ఇది ప్రధాన సమాచార కమిషనర్ లేకుండా పనిచేస్తోంది.",
  rti_bk_reduced: "కేసులు పేరుకుపోతున్నా, చట్టం అనుమతించే కంటే తక్కువ మంది కమిషనర్లతో ఇది పనిచేస్తోంది.",
  rti_bk_none: "నివేదిక సారాంశంలో ఈ కమిషన్‌కు విడిగా అంకె లేదు.",
  rti_bk_all: "దేశవ్యాప్తంగా 30 జూన్ 2025 నాటికి {n} అప్పీళ్లు, ఫిర్యాదులు పెండింగ్‌లో ఉన్నాయి. 29 కమిషన్లలో 18 కమిషన్లకు 1 జూలై 2025న దాఖలైన కేసును పరిష్కరించడానికి ఏడాది కంటే ఎక్కువ పడుతుంది. మొదటి అప్పీల్‌ను సమయానికి దాఖలు చేయండి: అది మీ చేతుల్లో ఉన్న అడుగు.",
  rti_bk_src: "మూలం: సతర్క్ నాగరిక్ సంగఠన్, భారతదేశంలో సమాచార కమిషన్ల పనితీరుపై రిపోర్ట్ కార్డ్, 2024-25 (పత్రికా ప్రకటన, 9 అక్టోబర్ 2025).",
  home_rti_n1: "17,50,863",
  home_rti_s1: "2023-24లో దాఖలైన RTI దరఖాస్తులు, రాజ్యసభలో కేంద్ర ప్రభుత్వ సమాధానం ప్రకారం.",
  home_rti_n2: "4,13,972",
  home_rti_s2: "30 జూన్ 2025 నాటికి భారతదేశంలోని 29 సమాచార కమిషన్లలో పెండింగ్‌లో ఉన్న అప్పీళ్లు, ఫిర్యాదులు.",
  home_rti_n3: "29 ఏళ్లు",
  home_rti_s3: "తెలంగాణ కమిషన్‌లో 1 జూలై 2025న దాఖలైన కేసుకు అంచనా నిరీక్షణ.",
  home_rti_next: "RTI పని ప్రమాదంగా మారిన కొద్దిమందికి, తదుపరి రక్షణ వాల్ట్.",
  hero_cta_rti: "మీ RTI గడువు చూడండి",
  rti_tally_line: "ఈ కమిషన్ కోసం ఈ గడియారంతో నమోదైన దరఖాస్తులు: {n}, వాటిలో {late} జవాబు గడువు దాటాయి. లెక్క నేరుగా Arkiv నుంచి.",
  rti_tally_zero: "ఈ కమిషన్ కోసం ఇంకా ఏ దరఖాస్తూ పబ్లిక్ లెక్కలో చేరలేదు.",
  rti_tally_note: "దరఖాస్తు నమోదు చేసేటప్పుడు దరఖాస్తుదారులే లెక్కలో చేరాలని ఎంచుకుంటారు. ఎవరైనా లెక్కకు జోడించవచ్చు, కాబట్టి దీన్ని దరఖాస్తుదారుల సంకేతంగా చూడండి, కమిషన్ ఆడిట్‌గా కాదు.",
  rti_tally_opt: "ఈ దరఖాస్తును {name} పబ్లిక్ లెక్కలో కూడా, పేరు లేకుండా, చేర్చండి. Arkiv‌లోకి కమిషన్, జవాబు గడువు మాత్రమే వెళ్తాయి.",
  rti_tally_pick: "ఈ దరఖాస్తును ఒక కమిషన్ పబ్లిక్ లెక్కలో చేర్చడానికి, పైన మీ సమాచార కమిషన్‌ను ఎంచుకోండి.",
  // Key, check-in, custodian and sealing flows
  nv_reused: "ఈ ఆహ్వాన కోడ్‌లలో ఒకటి ఇప్పటికే వేరే వాల్ట్‌కు కాపలాగా ఉంది. దాన్ని మళ్లీ వాడితే Arkiv‌లో మీ వాల్ట్‌లు కలిసిపోతాయి. ఆ సంరక్షకుడిని కొత్త ఆహ్వాన కోడ్ అడగండి.",
  kg_no_key_activist: "ఈ పాస్‌ఫ్రేజ్‌తో ఈ బ్రౌజర్‌లో ఏ కార్యకర్త కీ తెరుచుకోదు.",
  kg_no_key_custodian: "ఈ పాస్‌ఫ్రేజ్‌తో ఈ బ్రౌజర్‌లో ఏ సంరక్షకుడి కీ తెరుచుకోదు.",
  kg_short: "కనీసం 8 అక్షరాలు వాడండి. ఒక చిన్న వాక్యం ఉత్తమం.",
  kg_differ: "రెండు పాస్‌ఫ్రేజ్‌లు వేర్వేరుగా ఉన్నాయి.",
  kg_ready_t: "మీ కీ సిద్ధంగా ఉంది",
  kg_ready_b: "ఒక బ్యాకప్ ఫైల్ ఇప్పుడే డౌన్‌లోడ్ అయింది. దాన్ని ఈ ఫోన్‌కు దూరంగా, ఉదాహరణకు మీరు నమ్మే వ్యక్తి దగ్గర ఉంచండి. మీ పాస్‌ఫ్రేజ్ లేకుండా అది కొన్ని యాదృచ్ఛిక అక్షరాలు మాత్రమే.",
  kg_ready_warn: "ఈ బ్రౌజర్, బ్యాకప్ రెండూ పోతే మీరు చెక్-ఇన్ చేయలేరు, గడువు దాటగానే వాల్ట్ విడుదలవుతుంది. ఇది అలాగే పనిచేయాలి.",
  kg_continue: "కొనసాగించండి",
  kg_again: "బ్యాకప్‌ను మళ్లీ డౌన్‌లోడ్ చేయండి",
  kg_addr: "కీ చిరునామా",
  kg_unlock: "తెరవండి",
  kg_unlocking: "తెరుస్తోంది…",
  kg_new: "కొత్త కీ తయారు చేయండి",
  kg_restore: "బ్యాకప్‌ను పునరుద్ధరించండి",
  kg_restored: "{n} కీ(లు) పునరుద్ధరించబడ్డాయి. పాస్‌ఫ్రేజ్ నమోదు చేయండి.",
  kg_pass: "పాస్‌ఫ్రేజ్",
  kg_label: "మీకు మాత్రమే కనిపించే ఒక లేబుల్",
  kg_label_hint: "తెరిచిన తర్వాత కీలను వేరుగా గుర్తించడానికి కనిపిస్తుంది. ఎప్పుడూ అసలు పేరు వాడకండి.",
  kg_pass_hint: "కనీసం 8 అక్షరాలు. మీరు మాత్రమే రాసే ఒక వాక్యం బాగా పనిచేస్తుంది. ప్రతి వాల్ట్‌కూ ఒకటే వాడవచ్చు.",
  kg_pass2: "పాస్‌ఫ్రేజ్ మళ్లీ",
  kg_duress: "ఒత్తిడి పాస్‌ఫ్రేజ్ (ఐచ్ఛికం)",
  kg_duress_hint: "ఎవరైనా బలవంతంగా చెక్-ఇన్ చేయిస్తే, దీన్ని వాడండి. చెక్-ఇన్ మీ స్క్రీన్‌పై, పబ్లిక్ వాల్ట్ పేజీలో సాధారణంగానే కనిపిస్తుంది. దానితో వెళ్లే ఎన్‌క్రిప్ట్ చేసిన నోట్ మీ సంరక్షకులకు వెంటనే విడుదల చేయమని చెబుతుంది. ఒత్తిడి పాస్‌ఫ్రేజ్ ఉందని ఈ ఫోన్‌లో ఏదీ చూపదు.",
  kg_making: "కీ తయారవుతోంది…",
  kg_make: "కీ తయారు చేసి దాని బ్యాకప్ డౌన్‌లోడ్ చేయండి",
  ci_gate_t: "చెక్-ఇన్ చేయడానికి తెరవండి",
  ci_gate_i: "ఒక పాస్‌ఫ్రేజ్ ఈ బ్రౌజర్‌లోని ప్రతి వాల్ట్ కీని తెరుస్తుంది.",
  ci_jitter_wait: "మీ చెక్-ఇన్ సుమారు {m} నిమిషాల్లో వెళ్తుంది. ఈ పేజీని తెరిచే ఉంచండి.",
  ci_done: "{time}కి చెక్-ఇన్ అయింది. మీ పత్రాలు సీల్‌లోనే ఉంటాయి.",
  ci_busy: "చెక్-ఇన్ అవుతోంది…",
  ci_btn_one: "నేను క్షేమం · 1 వాల్ట్ చెక్-ఇన్ చేయండి",
  ci_btn_many: "నేను క్షేమం · {n} వాల్ట్‌లు చెక్-ఇన్ చేయండి",
  ci_jitter: "రాబోయే 1 నుంచి 20 నిమిషాల్లో ఏదో ఒక సమయంలో పంపండి",
  ci_none: "ఈ కీల ఏ వాల్ట్‌కూ ఇప్పుడు హార్ట్‌బీట్ లేదు.",
  ci_key: "కీ",
  ci_due: "తదుపరి చెక్-ఇన్ {d}లో",
  ci_grace: "మీరు గ్రేస్ వ్యవధిలో ఉన్నారు. ఇప్పుడే చెక్-ఇన్ చేయండి.",
  cu_title: "సంరక్షకులు",
  cu_intro: "మీ దగ్గర ఒక కీలో ఒక ముక్క ఉంటుంది. ఒంటరిగా అది ఏమీ బయటపెట్టదు. మీరు రెండు మాటలిస్తారు: హార్ట్‌బీట్ ఆలస్యమైతే కార్యకర్తను సంప్రదించడానికి ప్రయత్నిస్తారు, అది ఆగిపోతే మీ ముక్కను ప్రచురిస్తారు. ప్రతి వాల్ట్‌కూ కొత్త కీ వాడండి, అప్పుడు Arkiv‌లో ఏదీ మీ వాల్ట్‌లను ఒకదానితో ఒకటి గానీ మీతో గానీ కలపదు.",
  cu_gate_stored: "మీ సంరక్షక కీలను తెరవండి, లేదా కొత్త వాల్ట్ కోసం ఒకటి తయారు చేయండి",
  cu_gate_new: "ఒక వాల్ట్ కోసం సంరక్షక కీ తయారు చేయండి",
  cu_another: "మరో సంరక్షక కీ తయారు చేయండి",
  cu_invite: "ఆహ్వాన కోడ్",
  cu_invite_b: "మీరిద్దరూ నమ్మే మార్గంలో దీన్ని కార్యకర్తకు పంపండి. ఇందులో ఈ కీ యొక్క పబ్లిక్ భాగం మాత్రమే ఉంటుంది.",
  cu_looking: "ఈ కీ పేరున్న వాల్ట్‌ల కోసం వెతుకుతోంది…",
  cu_none: "ఇంకా ఏ వాల్ట్‌లోనూ ఈ కీ లేదు. కార్యకర్త మీ ఆహ్వాన కోడ్‌తో వాల్ట్ సీల్ చేయగానే ఇక్కడ కనిపిస్తుంది.",
  cu_slot: "{n}లో స్లాట్ {slot} · విడుదలకు {k} కావాలి",
  cu_duress: "కార్యకర్త చివరి చెక్-ఇన్ ఒత్తిడి పాస్‌ఫ్రేజ్‌తో జరిగింది. ఇది మీకు, ఇతర సంరక్షకులకు మాత్రమే కనిపిస్తుంది. మీ ముక్కను ఇప్పుడే ప్రచురించండి.",
  cu_overdue: "కార్యకర్త ఆలస్యం చేశారు. మీరు ఒప్పుకున్న మార్గంలో ఇప్పుడే వారిని సంప్రదించండి.",
  cu_renewed: "సంరక్షణ 14 రోజులకు పునరుద్ధరించబడింది.",
  cu_confirmed: "సంరక్షణ నిర్ధారించబడింది.",
  cu_renew: "సంరక్షణ పునరుద్ధరించండి ({left} మిగిలింది)",
  cu_confirm: "నా దగ్గర కీ ఉందని నిర్ధారించండి",
  cu_published: "మీ ముక్క పబ్లిక్ అయింది.",
  cu_piece_done: "ముక్క ప్రచురించబడింది",
  cu_publish: "నా ముక్కను ప్రచురించండి",
  cu_early: "హార్ట్‌బీట్ ఆగిన తర్వాతే ప్రచురణ సాధ్యం. యాప్, CLI రెండూ ముందు అనుమతించవు, ముందే ప్రచురించిన ముక్క వాల్ట్ పేజీలో గుర్తించబడుతుంది.",
  cu_watch_t: "మీ సొంత వాచర్‌ను నడపండి",
  cu_watch_b: "ఈ పేజీని తెరిచి ఉంచాల్సిన అవసరం లేదు. మీ సొంత కంప్యూటర్‌లో ఒక వాచర్, లేదా మీ సొంత GitHub ఖాతాలో గంటకోసారి నడిచే పని, మీ సంరక్షణను పునరుద్ధరిస్తుంది, హార్ట్‌బీట్ ఆగగానే లేదా ఒత్తిడి చెక్-ఇన్ రాగానే మీ ముక్కను ప్రచురిస్తుంది. ఇందులో మాది ఏదీ ఉండదు. కార్యకర్త ఆలస్యం చేస్తే ఆ పని విఫలమై GitHub మీకు ఈమెయిల్ చేస్తుంది.",
  cu_watch_link: "వాచర్‌ను సెటప్ చేయండి",
  nv_rh_daily: "ప్రతి రోజు",
  nv_rh_weekly: "ప్రతి వారం",
  nv_rh_fortnight: "ప్రతి రెండు వారాలు",
  nv_rh_monthly: "ప్రతి నెల",
  nv_rh_test: "పరీక్ష: ప్రతి 10 నిమిషాలు",
  nv_gate_t: "ఈ వాల్ట్ కోసం కొత్త కీ",
  nv_gate_i: "ప్రతి వాల్ట్‌కూ సొంత కీ ఉంటుంది. Arkiv‌లో ఒక కీ రాసినదంతా ఒక్క క్వెరీతో జాబితా చేయవచ్చు, కాబట్టి ప్రతి వాల్ట్‌కూ కొత్త కీ ఉంటే రెండు వాల్ట్‌లు ఒకే వ్యక్తివని ఎవరూ చెప్పలేరు. అన్నింటికీ ఒకే పాస్‌ఫ్రేజ్ వాడవచ్చు.",
  nv_enc: "ఈ బ్రౌజర్‌లో {n} ఫైల్(లు) ఎన్‌క్రిప్ట్ అయ్యాయి; {c} ఎన్‌క్రిప్టెడ్ భాగాలు.",
  nv_owngas_wait: "మీ సొంత వాలెట్ లేదా ఫాసెట్ నుంచి Arkiv Tiramisu‌లో {addr}కి కనీసం {glm} GLM పంపండి. వేచి ఉంది…",
  nv_chunk: "భాగం {d}/{t} సీల్ అయింది",
  nv_manifest: "మానిఫెస్ట్, కవర్లు, హార్ట్‌బీట్ కలిసి సీల్ అయ్యాయి",
  nv_done_t: "సీల్ అయింది. మీ హార్ట్‌బీట్ మొదలైంది.",
  nv_done_b: "{i}లోపు చెక్-ఇన్ చేయండి. ఆ తర్వాత {g} గ్రేస్ ఉంటుంది.",
  nv_send_link: "ఈ లింక్‌ను ప్రతి సంరక్షకుడికి పంపండి",
  nv_open: "వాల్ట్ పేజీ తెరవండి",
  nv_checkin: "చెక్-ఇన్ పేజీ",
  nv_s1: "1 · పత్రాలు",
  nv_s1_b: "కంప్రెషన్ తర్వాత సుమారు 1.4 MB వరకు. RTI జవాబుల ఫోటోలు ముందుగా ఈ ఫోన్‌లోనే చిన్నవి చేయబడతాయి, కాబట్టి చాలా పేజీల జవాబు సాధారణంగా సరిపోతుంది. ఈ టెస్ట్‌నెట్‌లో పరీక్ష పత్రాలు మాత్రమే.",
  nv_count: "{n} ఫైల్(లు) · {size}",
  nv_too_big: "చాలా పెద్దది. మొత్తం 1.4 MB లోపు ఉంచండి.",
  nv_title_l: "శీర్షిక (ఎన్‌క్రిప్ట్ చేయబడింది, విడుదల తర్వాతే చదవగలరు)",
  nv_note_l: "విడుదల తర్వాత చదివేవారికి ఒక నోట్ (ఎన్‌క్రిప్ట్ చేయబడింది)",
  nv_s2: "2 · సంరక్షకులు",
  nv_s2_b: "ప్రతి వ్యక్తినీ సంరక్షకుల పేజీ తెరిచి వారి ఆహ్వాన కోడ్ పంపమని అడగండి. ప్రతి కోడ్ మీ వాల్ట్ కోసమే తయారైన కొత్త కీ, కాబట్టి Arkiv‌లో ఏదీ దాన్ని వారెవరో అనే దానితో కలపదు.",
  nv_add: "సంరక్షకుడిని జోడించండి",
  nv_dup: "ఒకే సంరక్షకుడు రెండుసార్లు ఉన్నారు.",
  nv_k: "విడుదలకు ఎంతమంది కలిసి పనిచేయాలి: {n}లో {k}",
  nv_k_hint: "రెండు లేదా ఎక్కువ ఉంటే ఒక్క సంరక్షకుడు ఒంటరిగా ఏమీ చేయలేరు. అందరికంటే తక్కువ ఉంటే ఒకరు అందుబాటులో లేకపోయినా పని జరుగుతుంది.",
  nv_s3: "3 · లయ, విడుదల",
  nv_grace: "గ్రేస్ {d}",
  nv_public: "అందరికీ విడుదల చేయండి. తగినన్ని ముక్కలు వచ్చాక ఎవరైనా పత్రాలు తెరవవచ్చు.",
  nv_newsroom: "ఒక వార్తా సంస్థకు విడుదల చేయండి. ముక్కలు దాని కీకి సీల్ అవుతాయి; ఏదైనా ప్రచురించే ముందు దాని సంపాదకులు పత్రాలను తనిఖీ చేస్తారు.",
  nv_newsroom_ph: "వార్తా సంస్థ పబ్లిక్ కీ, 0x02… లేదా 0x03…",
  nv_anyone_t: "ఎవరైనా సాక్ష్యాన్ని నిలిపి ఉంచేలా అనుమతించండి",
  nv_anyone_b: "సిఫార్సు చేయబడింది. విడుదల తర్వాత మద్దతుదారులు ఎన్‌క్రిప్టెడ్ డేటా ఆయుష్షును పెంచగలరు, అది మీ తర్వాత కూడా నిలుస్తుంది. ఆపేస్తే దాని ఆయుష్షు మీ చేతుల్లోనే ఉంటుంది.",
  nv_owngas_t: "గ్యాస్‌ను నా సొంత వాలెట్ నుంచి చెల్లించండి",
  nv_owngas_b: "ఆఫ్: ఒక షేర్డ్ ట్యాప్ ఈ కీకి కొంచెం టెస్ట్ GLM పంపుతుంది, ఆ ట్యాప్ చిరునామా అది నిధులిచ్చిన ప్రతి కీనీ కలుపుతుంది. ఆన్: ఈ కీకి GLM మీరే పంపండి, ఉదాహరణకు ఫాసెట్‌లోని \"Use a different address\"తో.",
  nv_listed_t: "ఈ వాల్ట్‌ను పబ్లిక్ డైరెక్టరీలో చేర్చండి",
  nv_listed_b: "డిఫాల్ట్‌గా ఆఫ్. జాబితాలో లేని వాల్ట్‌కు ప్రాజెక్ట్ ట్యాగ్ గానీ స్పష్టమైన టైప్ గానీ ఉండదు, కాబట్టి ఏ శోధనా దాన్ని చూపదు. మొత్తం చెయిన్‌ను స్కాన్ చేసేవారు ఒక వాల్ట్ ఉందని గమనించవచ్చు, కానీ అందులో ఏముందో, అది ఎవరిదో ఎప్పటికీ కాదు.",
  nv_what: "Arkiv‌లోకి ఏం వెళ్తుంది",
  nv_pub_h: "పబ్లిక్, ఎప్పటికీ చదవగలిగేది",
  nv_you_h: "మీ దగ్గరే ఉంటుంది",
  nv_r1a: "ఎన్‌క్రిప్టెడ్ భాగాలు, వాటి హ్యాష్‌లు",
  nv_r1b: "ఫైళ్లు, శీర్షిక, నోట్",
  nv_r2a: "ప్రతి సంరక్షకుడి ఒక్కసారి చిరునామా, పబ్లిక్ కీ",
  nv_r2b: "సంరక్షకులు ఎవరు",
  nv_r3a: "మీ హార్ట్‌బీట్, దాని గడువు",
  nv_r3b: "మీ కీ, పాస్‌ఫ్రేజ్",
  nv_r4a: "{n}లో {k}, లయ, విడుదల విధానం",
  nv_r4b: "మిమ్మల్ని గుర్తించే ఏదైనా, వాల్ట్‌కు మీరు ఇచ్చే ఏ లేబుల్ అయినా",
  nv_watch: "చెయిన్‌ను గమనించేవారు మీరు ఎప్పుడు చెక్-ఇన్ చేస్తారో చూడగలరు, Arkiv నోడ్ మీరు చెక్-ఇన్ చేసే IP చిరునామాను చూస్తుంది. మీరు ఎలాగూ ఆన్‌లైన్‌లో ఉండే సమయాల్లో, Tor లేదా మీరు ఇప్పటికే వాడే VPN ద్వారా చెక్-ఇన్ చేయండి.",
  nv_agree: "సీల్ అయ్యాక ఈ వాల్ట్‌ను ఎవరూ, నేను కూడా, తొలగించలేరని, చెక్-ఇన్ తప్పితే అది విడుదలవుతుందని నాకు అర్థమైంది. ఇవి చట్టబద్ధంగా పొందిన రికార్డులు, వీటిలో రహస్య సమాచారం గానీ వేరొకరి వ్యక్తిగత సమాచారం గానీ లేవు.",
  nv_sealing: "సీల్ అవుతోంది…",
  nv_seal: "సీల్ చేసి నా హార్ట్‌బీట్ మొదలుపెట్టండి",

  dr_kicker: "ఐదు నిమిషాల డ్రిల్",
  dr_title: "ఒక వాల్ట్ బతకడం, ఆగిపోవడం, బయటపెట్టడం చూడండి.",
  dr_body: "ఈ ట్యాబ్ ఒక కార్యకర్తగా, ముగ్గురు సంరక్షకులుగా పనిచేస్తుంది. ప్రతి అడుగు Arkiv Tiramisu టెస్ట్‌నెట్‌లో నిజమైన లావాదేవీ, దాని లింక్‌తో సహా. గడియారాన్ని కుదించాం: ప్రతి నిమిషం చెక్-ఇన్, ఒక నిమిషం గ్రేస్.",
  dr_note_label: "సింథటిక్ RTI సమాధానంతో పాటు సీల్ చేయాల్సిన ఒక వాక్యం",
  dr_note_default: "అసలు లెక్కలు కొలతల పుస్తకంలో 14వ పేజీలో ఉన్నాయి.",
  dr_unreachable: "అవసరమైన సమయానికి సంరక్షకుడు 2 అందుబాటులో ఉండరు",
  dr_forge: "ఒక మోసగాడు నకిలీ ముక్కను ప్రచురించడానికి ప్రయత్నిస్తాడు",
  dr_start: "డ్రిల్ ప్రారంభించండి",
  dr_public: "వాల్ట్ పబ్లిక్ పేజీ →",
  dr_due: "తదుపరి చెక్-ఇన్:",
  dr_now: "ఇప్పుడే",
  dr_stops: "గుండె ఆగడానికి:",
  dr_pieces: "{k} లో {have} ముక్కలు బహిరంగం",
  dr_checkin: "చెక్-ఇన్ చేయండి",
  dr_force: "బలవంతంగా తొలగించండి",
  dr_or: "లేదా ఏమీ నొక్కకుండా గడువు దాటనివ్వండి.",
  dr_out_t: "పత్రాలు బయటకు వచ్చాయి.",
  dr_out: "పబ్లిక్ పేజీని మరో బ్రౌజర్‌లో, మరో ఫోన్‌లో లేదా CLI ద్వారా తెరవండి. అది Arkiv లోని ముక్కలతో తాళంచెవిని మళ్లీ తయారుచేసి పత్రాలను తెరుస్తుంది, ఈ ట్యాబ్ లేదా మా సర్వర్ల సహాయం లేకుండా.",
  dr_open: "వాల్ట్ పబ్లిక్ పేజీ తెరవండి",
  dr_log_t: "Arkiv లో ఇప్పుడేం జరిగింది",
  dr_log_none: "ఇంకా ఏమీ లేదు.",
  dr_activist: "కార్యకర్త",
  dr_c1: "సంరక్షకుడు 1 · జర్నలిస్ట్",
  dr_c2: "సంరక్షకుడు 2 · లాయర్",
  dr_c3: "సంరక్షకుడు 3 · స్నేహితుడు",
  dr_forger: "మోసగాడు",
  dr_l_keys: "ఈ ట్యాబ్‌లో 5 కొత్త కీలు తయారయ్యాయి. కార్యకర్త {a}.",
  dr_l_tap: "కార్యకర్తకు ట్యాప్ నుండి టెస్ట్ గ్యాస్ అందింది.",
  dr_l_gas: "{name} కు గ్యాస్",
  dr_l_enc: "బ్రౌజర్‌లో 2 ఫైళ్లు ఎన్‌క్రిప్ట్ అయ్యాయి. తాళంచెవి 3 లో 2 గా విభజించబడింది. వాల్ట్ {v}.",
  dr_l_chunk: "ఎన్‌క్రిప్ట్ చేసిన భాగం {d}/{t} రాసి సీల్ చేయబడింది",
  dr_l_batch: "మానిఫెస్ట్, 3 కవర్లు, గుండె చప్పుడు ఒకే బ్యాచ్‌లో రాయబడ్డాయి",
  dr_l_ack: "{name} తాళంచెవి ముక్క తమ దగ్గర ఉందని ధృవీకరించారు",
  dr_l_beat: "కార్యకర్త చెక్-ఇన్ చేశారు",
  dr_l_coerce: "బలవంతం: కార్యకర్తతో బలవంతంగా గుండె చప్పుడును తొలగింపజేస్తారు. దాని వల్ల అది ఇంకా త్వరగా ఆగుతుంది, అంతే.",
  dr_l_gone: "సంరక్షకుల నిఘా: గుండె చప్పుడు కనిపించలేదు. విడుదల చేస్తున్నారు.",
  dr_l_fake: "ఒక మోసగాడు స్లాట్ 2 కి నకిలీ ముక్కను ప్రచురించాడు",
  dr_l_unreach: "సంరక్షకుడు 2 అందుబాటులో లేరు. 3 లో 2 ఉన్నా సరిపోతుంది.",
  dr_l_piece: "{name} ఒక ముక్కను ప్రచురించారు",
  vf_lead: "ఈ వెబ్‌సైట్ రేపు మాయమైనా, ప్రతి వాల్ట్ Arkiv లోనే ఉంటుంది, వీటిలో ఏదైనా దాన్ని చదవగలదు.",
  vf_cli_t: "CLI",
  vf_cli: "టెర్మినల్ నుండే స్థితి చూడండి, గమనించండి, విడుదల చేయండి, తెరవండి. బ్రౌజర్ అక్కర్లేదు, సైట్ అక్కర్లేదు.",
  vf_curl: "{rpc} కు ఒక JSON-RPC కాల్.",
  vf_src_t: "సోర్స్ కోడ్",
  vf_src: "MIT లైసెన్స్, /arkiv/schema.md లో డేటా ఒప్పందం, కాబట్టి ఎవరైనా మరో రీడర్ తయారుచేయవచ్చు.",
  vf_run_t: "ఒక క్వెరీ నడపండి",
  vf_run: "Arkiv పై నడపండి",
  why_1_n: "107+",
  why_3_n: "0",
  t_ago: "క్రితం",
  common_tx: "లావాదేవీ",
  common_block: "బ్లాక్",
  f1_chip_2: "సృష్టించినప్పుడే హాష్‌లు సీల్",
  f2_chip_1: "n లో k",
  f2_chip_2: "ప్రతి వాల్ట్‌కు కొత్త సంరక్షక కీ",
  f2_chip_3: "న్యూస్‌రూమ్‌కు విడుదల",
  f3_chip_1: "వారానికి లేదా నెలకు",
  f3_chip_2: "గ్రేస్ వ్యవధి",
  f3_chip_3: "ఒత్తిడి పాస్‌ఫ్రేజ్",
  f4_chip_1: "నకిలీ ముక్కలు లెక్కలోకి రావు",
  f4_chip_2: "ఏ బ్రౌజర్‌లోనైనా తెరుచుకుంటుంది",
  tile_1_t: "డేటాబేసే అమలు చేసే గడువు",
  tile_1: "గుండె చప్పుడు ఒక Arkiv ఎంటిటీ, అది ఒక విరామం ప్లస్ గ్రేస్ వరకు ఉంటుంది. ఎవరూ పొడిగించకపోతే Arkiv దాన్ని తీసేస్తుంది.",
  tile_2_t: "ఎవరూ తొలగించలేని డేటా",
  tile_2: "సీల్ చేసిన ప్రతి ముక్క చదవడానికి మాత్రమే, రాసిన బ్లాక్ నుండే ఎవరి దగ్గరా కీ లేని ఒక చిరునామాకు చెందుతుంది.",
  tile_3_t: "ఎవరూ నకిలీ చేయలేని రచయిత గుర్తింపు",
  tile_3: "ఒక ముక్క ఆన్-చెయిన్‌లో సృష్టించిన వారు ఆ స్లాట్‌కు పేర్కొన్న సంరక్షకుడే అయితేనే అది లెక్కలోకి వస్తుంది.",
  tile_4_t: "మా అవసరం లేకుండానే చదవొచ్చు",
  tile_4: "ఈ సైట్, కమాండ్-లైన్ టూల్, ఒక curl కమాండ్, మూడూ అవే పబ్లిక్ ఎంటిటీలను చదువుతాయి.",
  tile_5_t: "WebSocket ద్వారా లైవ్",
  tile_5: "చెక్-ఇన్‌లు, విడుదలలు చెయిన్‌పైకి వచ్చిన క్షణమే తెరిచి ఉన్న ప్రతి వాల్ట్ పేజీలో కనిపిస్తాయి.",
  tile_6_t: "మీ ఫోన్‌లో ఏమీ దాచబడదు",
  tile_6: "కీలు మీ పాస్‌ఫ్రేజ్‌తో సీల్ అయి ఉంటాయి, యాప్ జాబితా దాచుకోకుండా మీ వాల్ట్‌లను Arkiv లోనే వెతుకుతుంది.",
  faq_4_q: "సంరక్షకుడు నా పత్రాలను ముందే చదవగలరా?",
  faq_4_a: "ఒక్క ముక్కతో ఏమీ తెలియదు. గుండె చప్పుడు నడుస్తుండగా ప్రచురించిన ముక్కలు వాల్ట్ పేజీలో ముందస్తు విడుదలగా గుర్తించబడతాయి, k కంటే తక్కువ ముక్కలతో ఏమీ తెరుచుకోదు.",
  faq_5_q: "చెయిన్‌ను గమనించేవారికి ఏం కనిపిస్తుంది?",
  faq_5_a: "యాదృచ్ఛిక ఐడీలు, ఎన్‌క్రిప్ట్ చేసిన డేటా, ఒక గడువు, మీరు చెక్-ఇన్ చేసే సమయాలు. పేర్లు, శీర్షికలు, ఏ వాల్ట్‌లు ఒకే వ్యక్తివో కనిపించవు. చెక్-ఇన్ సమయాలు కనిపిస్తాయి, కాబట్టి మీరు ఎలాగూ ఆన్‌లైన్‌లో ఉండే సమయాల్లోనే చెక్-ఇన్ చేయండి.",
  faq_6_q: "ఇది చట్టబద్ధమేనా?",
  faq_6_a: "మీరు దగ్గర ఉంచుకోవడానికి అనుమతి ఉన్న రికార్డుల కోసం ఇది ఎన్‌క్రిప్షన్ సాఫ్ట్‌వేర్: RTI సమాధానాలు, పబ్లిక్ రికార్డులు, మీ సొంత సాక్ష్యాలు. రహస్య సమాచారాన్ని లేదా ఇతరుల వ్యక్తిగత సమాచారాన్ని సీల్ చేయకండి. నిజమైన వాడకంలో న్యూస్‌రూమ్‌కు విడుదల ఎంచుకోండి, ఏదైనా ప్రచురించే ముందు ఎడిటర్లు పత్రాలను పరిశీలిస్తారు.",
  faq_7_q: "టెస్ట్ నెట్‌వర్క్ ఎందుకు?",
  faq_7_a: "ఈ బిల్డ్ Arkiv Global Tour Stop కోసం Arkiv Tiramisu టెస్ట్‌నెట్‌పై నడుస్తుంది. సింథటిక్ పత్రాలను మాత్రమే వాడండి.",
  vp_on_arkiv: "Arkiv లో",
  vp_chunks: "{n} ఎన్‌క్రిప్ట్ చేసిన భాగాలు, {size}, సీల్ చేసినవారు",
  vp_envelopes: "{n} లో {have} కీ కవర్లు సీల్ అయ్యాయి",
  vp_kept: "వాల్ట్ డేటా బ్లాక్ {b} వరకు ఉంటుంది (~{d})",
  vp_sealed_at: "బ్లాక్ {b} వద్ద సీల్ అయింది · {date}",
  vp_waiting: "చెక్-ఇన్‌లు, ధృవీకరణలు, విడుదలల కోసం ఎదురుచూస్తోంది…",
  vp_mismatch: "కొన్ని ఫైళ్లు సీల్ చేసిన హాష్‌తో సరిపోలడం లేదు.",
  vp_download: "డౌన్‌లోడ్",
  ka_gas: "టెస్ట్ గ్యాస్ తీసుకుంటోంది…",
  ka_none: "అన్నీ ఇప్పటికే కనీసం ఒక సంవత్సరం వరకు ఉంచబడ్డాయి.",
  ka_extending: "సీల్ చేసిన {n} ఎంటిటీలను పొడిగిస్తోంది…",
  ka_done: "పూర్తయింది",
  as_t: "గతంలోని ఒక బ్లాక్ వద్ద",
  as_d: "అదే క్వెరీ, Arkiv atBlock తో గతంలోని ఒక బ్లాక్ వద్ద చదివినది. ఆ క్షణంలో వాల్ట్ ఏ స్థితిలో ఉందో ఇది రుజువు చేస్తుంది, ఉదాహరణకు కార్యకర్త అప్పటికీ చెక్-ఇన్ చేస్తున్నారని.",
  as_read: "చదవండి",
  as_reading: "చదువుతోంది…",
  as_at: "బ్లాక్ {b} వద్ద: {phase}",
  as_hb: ", గుండె చప్పుడు బ్లాక్ {b} వరకు చెల్లుతుంది",
  as_nohb: ", గుండె చప్పుడు లేదు",
  as_pieces: ", {n} చెల్లుబాటయ్యే ముక్కలు.",
  vy_t: "మా అవసరం లేకుండా దీన్ని తనిఖీ చేయండి",
  vy_d: "ఈ పేజీలోని ప్రతి విషయం ఈ Arkiv క్వెరీల నుండే వస్తుంది. వీటిని ఏ Arkiv ఎండ్‌పాయింట్‌పైనైనా నడపండి.",
  ev_checkin: "బ్లాక్ {b} వద్ద చెక్-ఇన్",
  ev_activity: "బ్లాక్ {b} వద్ద సంరక్షకుల కార్యకలాపం",
  ev_deadline: "గడువు ముగిసింది; గుండె చప్పుడును తనిఖీ చేస్తోంది",
  hm_read: "Arkiv నుండి చదివినది",
  hm_at: "బ్లాక్ {b} వద్ద",
  hm_custodian: "సంరక్షకుడు {n}",
  hm_holding: "తాళంచెవి వారి దగ్గర ఉంది",
  hm_f1_t: "చెక్-ఇన్ అందింది",
  hm_f1: "గుండె చప్పుడు ముందుకు జరిగింది",
  hm_f2_t: "3 కవర్లు సీల్ అయ్యాయి",
  hm_f2: "యజమాని 0x…dEaD · ఎవరూ తొలగించలేరు",
  hm_f3_t: "సంరక్షకుడు 2 మళ్లీ ధృవీకరించారు",
  hm_f3: "లీజు 14 రోజులు పొడిగించబడింది",
  mk_enc: "ఈ బ్రౌజర్‌లోనే ఎన్‌క్రిప్ట్",
  mk_chunk: "భాగం {i}",
  mk_sealed: "సీల్",
  mk_2of3: "3 లో 2 మంది వాల్ట్ తెరుస్తారు",
  mk_journalist: "జర్నలిస్ట్",
  mk_lawyer: "లాయర్",
  mk_friend: "స్నేహితుడు",
  mk_slot: "స్లాట్ {n}",
  mk_piece: "తాళంచెవిలో ఒక ముక్క, ఒకసారి వాడే చిరునామాకు ఎన్‌క్రిప్ట్ చేయబడింది",
  mk_any2: "ఏ రెండు ముక్కలైనా తాళంచెవిని మళ్లీ తయారుచేస్తాయి. ఒక్క ముక్క మాత్రమే అయితే అది యాదృచ్ఛిక శబ్దం.",
  mk_next: "తదుపరి చెక్-ఇన్‌కు",
  mk_safe: "నేను క్షేమంగా ఉన్నాను · చెక్-ఇన్",
  mk_stopped: "బ్లాక్ {b} వద్ద గుండె ఆగింది",
  mk_published: "ముక్క ప్రచురించబడింది",
  mk_stranger: "{a} (అపరిచితుడు)",
  mk_ignored: "లెక్కలోకి రాదు: తప్పు సృష్టికర్త",
  mk_matches: "బ్లాక్ {b} వద్ద సీల్ చేసిన హాష్‌తో సరిపోలుతుంది",
  rh_week: "వారానికి",
  rh_fortnight: "పక్షానికి",
  rh_month: "నెలకు",
  vp_rhythm: "ప్రతి {i} · గ్రేస్ {g} · {n} లో {k} సంరక్షకులు · {mode}",
  vp_mode_newsroom: "న్యూస్‌రూమ్‌కు విడుదల",
  vp_mode_public: "బహిరంగ విడుదల",
  rj_vault: "వేరే సృష్టికర్త నుండి వచ్చిన వాల్ట్ ఎంటిటీ",
  rj_manifest: "అదే వాల్ట్‌కు రెండో మానిఫెస్ట్; మొదటిదే లెక్కలోకి వస్తుంది",
  rj_heartbeat: "గుండె చప్పుడును వాల్ట్ సృష్టికర్త రాయలేదు",
  rj_beat: "చెక్-ఇన్ నోట్‌ను వాల్ట్ సృష్టికర్త రాయలేదు",
  rj_envelope: "కవర్‌ను వాల్ట్ సృష్టికర్త రాయలేదు",
  rj_ack: "ఈ స్లాట్ సంరక్షకుడు కాని వాలెట్ నుండి ధృవీకరణ",
  rj_release: "ఈ స్లాట్ సంరక్షకుడు కాని వాలెట్ నుండి విడుదల",
  nav_rti: "RTI గడియారం",
  home_rti_eyebrow: "RTI దరఖాస్తు పెట్టారా?",
  home_rti_h2: "జవాబు ఏ రోజులోగా రావాలో తెలుసుకోండి.",
  home_rti_lead: "PIOకి మీ దరఖాస్తు అందిన తేదీ ఇవ్వండి. సమాచార హక్కు చట్టం ప్రకారం జవాబు గడువును, రెండు అప్పీళ్ల గడువులను RTI గడియారం చూపిస్తుంది. జవాబు రాకపోతే తెలుగు, హిందీ లేదా ఇంగ్లీషులో మొదటి అప్పీలు ముసాయిదా తయారు చేస్తుంది. ఇది ఈ రోజే ఏ ఫోన్‌లోనైనా పనిచేస్తుంది, మీరు రాసేది మీ బ్రౌజర్‌లోనే ఉంటుంది.",
  home_rti_cta: "RTI గడియారం తెరవండి",
  rti_eyebrow: "RTI గడియారం",
  rti_title: "మీ RTI జవాబు ఎప్పటిలోగా రావాలి?",
  rti_lead: "ప్రజా సమాచార అధికారి (PIO)కి మీ దరఖాస్తు ఎప్పుడు అందిందో ఇవ్వండి. సమాచార హక్కు చట్టం, 2005 ప్రకారం జవాబు గడువు, అప్పీళ్ల గడువులు ఇక్కడ కనిపిస్తాయి. గడువు జవాబు లేకుండా దాటితే మొదటి అప్పీలు ముసాయిదా కూడా వస్తుంది. మీరు రాసేది ఈ బ్రౌజర్‌లోనే ఉంటుంది.",
  rti_form_t: "మీ దరఖాస్తు",
  rti_received: "PIOకి దరఖాస్తు అందిన తేదీ",
  rti_received_hint: "పోస్టులో పంపితే ఇండియా పోస్ట్ ట్రాకింగ్‌లోని డెలివరీ తేదీ ఇవ్వండి. ఆన్‌లైన్ దరఖాస్తుకు ఈ తేదీ రసీదు మీద ఉంటుంది.",
  rti_time: "సమయం",
  rti_kind: "దరఖాస్తు దేని గురించి",
  rti_kind_normal: "మిగతా అన్నీ: 30 రోజులు",
  rti_kind_life: "ఒక వ్యక్తి ప్రాణం లేదా స్వేచ్ఛ: 48 గంటలు",
  rti_apio: "నేను సహాయ ప్రజా సమాచార అధికారి (APIO)కి ఇచ్చాను (మరో 5 రోజులు)",
  rti_fee: "PIO ఫీజు లేఖకు, మీ చెల్లింపుకు మధ్య రోజులు",
  rti_fee_hint: "PIO అదనపు ఫీజు అడగకపోతే దీన్ని 0గా వదిలేయండి. ఆ రోజులు గడువులో లెక్కలోకి రావు, సెక్షన్ 7(3)(a).",
  rti_tl_t: "మీ గడువులు",
  rti_due: "జవాబు గడువు",
  rti_due_s: "అప్పటిలోగా PIO సమాచారం ఇవ్వాలి, లేదా కారణాలతో తిరస్కరించాలి. సెక్షన్ 7(1)",
  rti_due_apio: "ఇందులో సహాయ PIO కోసం 5 రోజులు కలిపాం. సెక్షన్ 5(2)",
  rti_deemed: "ఏమీ రాకపోతే",
  rti_deemed_s: "మరుసటి రోజు నుంచి మౌనాన్ని తిరస్కరణగానే పరిగణిస్తారు, మీరు అప్పీలు చేయవచ్చు. ఆలస్యంగా జవాబిస్తే సమాచారం ఉచితంగా ఇవ్వాలి. సెక్షన్ 7(2), 7(6)",
  rti_fa: "మొదటి అప్పీలు గడువు",
  rti_fa_s: "మొదటి అప్పీలు అధికారికి, అంటే అదే ప్రభుత్వ సంస్థలో PIO కంటే పై అధికారికి. తగిన కారణం ఉంటే ఆలస్యంగా చేసిన అప్పీలునూ స్వీకరించవచ్చు. సెక్షన్ 19(1)",
  rti_faa: "అప్పీలుపై నిర్ణయం గడువు",
  rti_faa_s: "అప్పీలు అందిన 30 రోజుల్లోగా, గరిష్ఠంగా 45 రోజులు. ఇక్కడ {date} నుంచి లెక్కించాం. సెక్షన్ 19(6)",
  rti_sa: "రెండో అప్పీలు గడువు",
  rti_sa_s: "కేంద్ర లేదా రాష్ట్ర సమాచార కమిషన్‌కు, మొదటి అప్పీలు నిర్ణయం రావాల్సిన లేదా మీకు అందిన తేదీ నుంచి 90 రోజుల్లోగా. సెక్షన్ 19(3)",
  rti_left: "ఇంకా {n}",
  rti_passed: "గడువులోగా జవాబు రాలేదు",
  rti_source: "ఈ పేజీలోని ప్రతి గడువు సమాచార హక్కు చట్టం, 2005 నుంచి తీసుకున్నది. ఇది కేంద్ర, రాష్ట్ర ప్రభుత్వ సంస్థలన్నిటికీ వర్తిస్తుంది. ఫీజులు, ఫారాలు రాష్ట్రాన్ని బట్టి మారవచ్చు, కానీ ఈ గడువులు చట్టంలోనే ఉన్నాయి.",
  rti_source_link: "ఇండియా కోడ్‌లో చట్టం చదవండి",
  rti_rec_t: "Arkivలో సమయ ముద్ర వేయండి",
  rti_rec_lead: "ఇది ఐచ్ఛికం. దరఖాస్తు ఫైల్ ఎంచుకోండి లేదా దాని పాఠం అతికించండి. ఈ బ్రౌజర్ దాని SHA-256 వేలిముద్రను లెక్కించి, ఈ పరికరంలోనే తయారైన 32-బైట్ యాదృచ్ఛిక సాల్ట్‌తో కలుపుతుంది. చెయిన్ మీదికి ఆ సాల్ట్ కలిపిన విలువ, జవాబు గడువు బ్లాక్ మాత్రమే వెళ్తాయి. సాల్ట్ లేకుండా ఎవరూ ఊహించిన పత్రాన్ని గానీ పేరును గానీ దీంతో పోల్చి చూడలేరు, కాబట్టి మీరు ఏమి అడిగారో, మీరు ఎవరో రికార్డు చెప్పదు. దీన్ని మీరు గానీ మేము గానీ ఎవరూ మార్చలేరు, తొలగించలేరు. అది రాసిన బ్లాక్, దరఖాస్తు అప్పటికే ఉందని చూపిస్తుంది. అప్పీళ్ల గడువులన్నిటిలో అది చదవడానికి అందుబాటులో ఉంటుంది, జవాబు గడువుకు 165 రోజుల తర్వాత రెండో అప్పీలు గడువు ముగిసినప్పుడు దానంతట అదే ముగుస్తుంది (సెక్షన్ 19(1), 19(6), 19(3)).",
  rti_rec_net: "ఇది Arkiv టిరామిసు టెస్ట్‌నెట్‌పై నడుస్తుంది. పోస్టల్ లేదా ఆన్‌లైన్ రసీదును కూడా దాచుకోండి: PIOకి దరఖాస్తు అందిందనడానికి రుజువు అదే.",
  rti_rec_file: "దరఖాస్తు ఫైల్",
  rti_rec_text: "లేదా దరఖాస్తు పాఠం అతికించండి",
  rti_rec_hash: "వేలిముద్ర (SHA-256). ఇది ఈ పరికరంలోనే ఉంటుంది.",
  rti_rec_go: "Arkivలో నమోదు చేయండి",
  rti_rec_gas: "ఒకసారి వాడే కీ కోసం టెస్ట్ గ్యాస్ తెస్తున్నాం…",
  rti_rec_write: "రికార్డు రాస్తున్నాం…",
  rti_rec_late: "జవాబు గడువు దాటిపోయింది, కాబట్టి ఇప్పుడు చేసే రికార్డు ఏ గడువునూ కొలవదు. కింద అప్పీలు ముసాయిదా మాత్రం తయారు చేసుకోవచ్చు.",
  rti_rec_t2: "Arkivలో",
  rti_rec_by: "బ్లాక్ {block}లో నమోదైంది, {time}, ఒకసారి వాడే కీ {addr} ద్వారా.",
  rti_rec_live: "జవాబు గడువు బ్లాక్ {due}. రికార్డు బ్లాక్ {block} వరకు, అంటే 165 రోజుల తర్వాత చివరి అప్పీలు గడువు ముగిసే వరకు ఉంటుంది (సెక్షన్ 19(1), 19(6), 19(3)).",
  rti_rec_gone: "చివరి అప్పీలు గడువు ముగిసినప్పుడు, బ్లాక్ {block} వద్ద ముగిసింది. ఇక్కడ బ్లాక్ {at} నాటి స్థితిని చదివాం.",
  rti_rec_none: "ప్రతి నమోదుకూ కొత్త సాల్ట్ వస్తుంది. ఒక దరఖాస్తును ఒకసారే నమోదు చేసి, దాని రసీదు దాచుకోండి.",
  rti_rec_link: "ఈ లింక్ దాచుకోండి. దీంతో ఏ పరికరంలోనైనా ఈ రికార్డు, మీ గడువులు మళ్లీ తెరుచుకుంటాయి.",
  rti_rec_tx: "లావాదేవీ",
  rti_rec_rejected: "ఈ ట్యాగ్‌తో ఉన్న {n} ఎంటిటీలు తనిఖీలో విఫలమయ్యాయి, వాటిని పక్కన పెట్టాం.",
  rti_rec_receipt_s: "రసీదును ఇప్పుడే డౌన్‌లోడ్ చేసి దరఖాస్తుతో పాటు దాచుకోండి. అందులో సాల్ట్ ఉంది, అది ఇంకెక్కడా లేదు. రసీదు, దరఖాస్తు ఉంటే ఈ రికార్డు మీదేనని ఎవరైనా తనిఖీ చేయవచ్చు; రసీదు లేకపోతే రికార్డును దేనితోనూ పోల్చలేరు.",
  rti_rec_receipt: "రసీదు డౌన్‌లోడ్ చేయండి",
  rti_rec_commit: "Arkivలో సాల్ట్ కలిపిన విలువ:",
  rti_rec_needreceipt: "ఈ రికార్డు ఒక దరఖాస్తుదేనని చూపడానికి, దాని రసీదు తెరిచి పైన దరఖాస్తును ఎంచుకోండి.",
  rti_rec_badreceipt: "ఈ ఫైల్ Proof of Life RTI రసీదు కాదు, లేదా దాని సాల్ట్ అందులో ఉన్న విలువను ఇవ్వడం లేదు.",
  rti_rec_nomatch: "ఈ దరఖాస్తు రసీదుతో సరిపోలడం లేదు.",
  rti_rec_norecord: "ఈ రసీదు విలువతో చెల్లుబాటు అయ్యే రికార్డు Arkivలో దొరకలేదు.",
  rti_rec_match: "ఈ దరఖాస్తు రసీదుతో సరిపోతుంది, రసీదు Arkivలోని రికార్డుతో సరిపోతుంది.",
  rti_rec_open: "ఇంతకు ముందే నమోదు చేశారా? మీ రసీదు తెరవండి:",
  rti_letter_t: "మొదటి అప్పీలు, పంపడానికి సిద్ధం",
  rti_letter_early: "జవాబు గడువు ఇంకా రాలేదు. జవాబు రాకపోతే మీరు పంపాల్సిన లేఖ ఇదే.",
  rti_letter_lead: "తెలిసినవి నింపండి. ఖాళీలు బ్రాకెట్లలో ఉంటాయి, వాటిని చేత్తో నింపుకోండి. ఇక్కడి నుంచి ఏదీ ఎక్కడికీ వెళ్లదు.",
  rti_l_lang: "లేఖ భాష",
  rti_l_name: "మీ పేరు",
  rti_l_addr: "మీ చిరునామా",
  rti_l_auth: "ప్రభుత్వ సంస్థ",
  rti_l_pio: "PIO పేరు లేదా హోదా",
  rti_l_reg: "దరఖాస్తు లేదా రిజిస్ట్రేషన్ నంబర్",
  rti_l_subject: "మీరు అడిగిన సమాచారం (ఒక వాక్యం)",
  rti_l_reason: "అప్పీలు ఆలస్యానికి కారణం",
  rti_l_copy: "లేఖ కాపీ చేయండి",
  rti_l_print: "ప్రింట్ చేయండి",
  rti_ph_name: "[మీ పేరు]",
  rti_ph_addr: "[మీ చిరునామా]",
  rti_ph_auth: "[ప్రభుత్వ సంస్థ పేరు, చిరునామా]",
  rti_ph_pio: "[PIO పేరు లేదా హోదా]",
  rti_ph_reg: "[రిజిస్ట్రేషన్ నంబర్]",
  rti_ph_subject: "[మీరు కోరిన సమాచారం]",
  rti_ph_reason: "[ఆలస్యానికి కారణం]",
  rti_letter_body: "స్వీకర్త\nమొదటి అప్పీలు అధికారి\n{auth}\n\nపంపినవారు\n{name}\n{addr}\n\nతేదీ: {today}\n\nవిషయం: సమాచార హక్కు చట్టం, 2005 సెక్షన్ 19(1) కింద మొదటి అప్పీలు\n\nఅయ్యా/అమ్మా,\n\n1. {filed}న {auth} ప్రజా సమాచార అధికారి ({pio})కి సమాచార హక్కు చట్టం, 2005 సెక్షన్ 6 కింద నా దరఖాస్తు అందింది (రిజిస్ట్రేషన్ నంబర్ {reg}). అందులో నేను కోరిన సమాచారం: {subject}.\n\n2. చట్టంలోని సెక్షన్ 7(1) ప్రకారం {due}లోగా నిర్ణయం ఇవ్వాల్సి ఉంది. నాకు ఎలాంటి నిర్ణయం అందలేదు. సెక్షన్ 7(2) ప్రకారం నా అభ్యర్థనను తిరస్కరించినట్లుగా పరిగణించాలి.\n\n3. {timing}\n{record}\nకాబట్టి మీరు:\n(a) గడువు పాటించనందున, కోరిన సమాచారాన్ని సెక్షన్ 7(6) ప్రకారం ఉచితంగా ఇవ్వాలని ప్రజా సమాచార అధికారిని ఆదేశించాలని;\n(b) ఈ అప్పీలుపై సెక్షన్ 19(6)లో నిర్దేశించిన గడువులోగా నిర్ణయం తీసుకోవాలని\nకోరుతున్నాను.\n\nజతపరచినవి: RTI దరఖాస్తు ప్రతి, అది అందినట్లు రుజువు.\n\nభవదీయులు,\n{name}",
  rti_letter_intime: "ఈ అప్పీలును సెక్షన్ 19(1) అనుమతించిన ముప్పై రోజుల్లోగా దాఖలు చేస్తున్నాను.",
  rti_letter_late: "ఈ అప్పీలును సెక్షన్ 19(1)లోని ముప్పై రోజుల తర్వాత దాఖలు చేస్తున్నాను. ఆలస్యానికి కారణం: {reason}. కాబట్టి ఆ సెక్షన్ నిబంధన (proviso) కింద దీన్ని స్వీకరించవలసిందిగా కోరుతున్నాను.",
  rti_letter_record: "\n4. దరఖాస్తు సాల్ట్ కలిపిన వేలిముద్రను Arkiv నెట్‌వర్క్‌లో బ్లాక్ {block}లో {time}న నమోదు చేశాను. దరఖాస్తు అప్పటికే ఉందని ఇది చూపిస్తుంది: {link}\nఈ రికార్డును జతపరచిన దరఖాస్తు ప్రతితో పోల్చే రసీదు నా దగ్గర ఉంది.\n",
  vl_ignored: " · {m} లెక్కలోకి రాలేదు",
  vl_size: "{c} × 96 KiB ఎన్‌క్రిప్ట్ చేసిన డేటా · {d}న సీల్",
};
